import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import check from "../../imagenes/thanks/check.png";
import check2x from "../../imagenes/thanks/check@2x.png";
import cruz from "../../imagenes/thanks/cruz.png";
import cruz2x from "../../imagenes/thanks/cruz@2x.png";
import imgSmall from "../../imagenes/sobrePedraza/img-small-2.png";
import imgSmall2x from "../../imagenes/sobrePedraza/img-small-2@2x.png";
import { toast } from "react-toastify";
import { manejadorDeRespuesta, traerReservasPorUsuario } from "../../utils/Tools";
import useGlobal from "../../utils/useGlobal";
import { cobranzasAPI } from "../../utils/funcionesAPI";

const Finalizacion = (props) => {
  const token = sessionStorage.getItem("token");
  const { medioDePago, numeroReserva, estado } = props;
  // const tipoCliente = sessionStorage.getItem("tipoCliente");
  const { setCantidadReservas } = useGlobal();
  const [errorFirstData, setErrorFirstData] = useState('');

  useEffect(() => {
    traerReservasPorUsuario(props, token, setCantidadReservas);
    if (estado === 'error') {
      const data = JSON.stringify({
        peticion: "traerMensajeErrorFirstData",
        numeroReserva
      });
      cobranzasAPI(data).then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          setErrorFirstData(`: ${respuesta.data}`);
        }
      });
    }
  }, [token, estado, numeroReserva]);

  let texto = "";
  let texto2 = "La presente reserva tiene vencimiento de pago";
  let texto3 = "Muchas gracias por su compra";
  let texto4 = "exitosa";
  let resultado = true;

  switch (medioDePago) {
    case 2:
      texto =
        "Para realizar el deposito puede acercarse a cualquiera de las sucursales de los Bancos en los que tenemos cuentas (ver Formas de Pago). Luego deberá informar del deposito desde el panel de Mis Reservas.";
      break;
    case 1:
      texto =
        "Debera acercarse a nuestras oficinas para confirmar y abonar la Reserva. Para mayor informacion consulte la opcion sucursales de nuestra pagina web.";
      break;
    case 3:
      texto =
        "En las próximas horas verá reflejado el pago realizado a través de su tarjeta de crédito.";
      //return window.location.href = props.numeroReserva.data.response.sandbox_init_point;
      break;
    case 4:
      texto =
        "Aguarde unos instantes y será redirigido al panel para ingresar los datos de su tarjeta de credito.";
      toast.success(
        "Aguarde unos instantes y será redirigido al panel para ingresar los datos de su tarjeta de credito.",
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 6000,
          onClose: () => {
            window.location.href =
              "https://pedraza.com.ar/tarjetaTelefonica/index.php?reserva=" +
              numeroReserva;
            return null;
          },
        }
      );
      break;
    default:
  }

  /*switch (props.tipoCliente) {
      case "IND":
          texto2 = "Un representante se pondra en contacto con usted a la brevedad.";
        break;
      default:
        texto2 = "La presente reserva tiene vencimiento de pago";
      break;
    }*/

  switch (estado) {
    case "error":
      resultado = false;
      texto3 = "Pendiente de Pago" + errorFirstData;
      texto4 = "pendiente";
      texto = "Detectamos que no ha concluido el pago.";
      texto2 =
        "Su reserva ha sido generada pero falta abonarla. Si desea puede llamar a nuestras oficinas para mas información o puede abonarla ingresando desde el panel 'Mis Reservas'.";
      break;
    case "pendiente":
      resultado = false;
      texto3 = "Compra Pendiente";
      texto4 = "pendiente";
      texto = "Su pago está PENDIENTE";
      texto2 =
        "Su reserva ha sido generada pero falta abonarla. Si desea puede llamar a nuestras oficinas para mas información o puede abonarla ingresando desde el panel 'Mis Reservas'.";
      break;
    default:
      break;
  }

  return (
    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 thanks clearfix">
      {resultado ? (
        <img
          src={check}
          alt="Icono de un check"
          srcSet={check + " 1x, " + check2x + " 2x"}
        />
      ) : (
        <img
          src={cruz}
          alt="Icono de un check"
          srcSet={cruz + " 1x, " + cruz2x + " 2x"}
        />
      )}
      <h2 className={resultado ? "mensajeExito" : "mensajeError"}>{texto3}</h2>
      <div className="compra-resumen">
        <div className="img-container">
          <img
            src={imgSmall}
            alt="Imagen de fondo acerca de viajes"
            srcSet={imgSmall + " 1x, " + imgSmall2x + " 2x"}
          />
        </div>
        <div className="txt-container">
          <h6>compra {texto4}</h6>
          <h3>
            su n° de reserva es: <strong>{numeroReserva}</strong>
          </h3>
          <p>{texto2}</p>
          <p>{texto}</p>
          <p>
            <strong>
              Podr&aacute;s ver tus reservas desde la opci&oacute;n{" "}
            </strong>
            <Link to={`/panel-mis-reservas/`}>Mis Reservas</Link>
          </p>
        </div>
      </div>
      <br />
      <Link to="/" className="submitCargaPasajeros">
        Finalizar
      </Link>
    </div>
  );
};

export default Finalizacion;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Finalizacion.js